module.exports = __webpack_public_path__ + "img/sup_register_2.1fcdd01b.png";